<div class="confirm-container">
  <span mat-dialog-title>Mark Deal as Dead</span>
  <div mat-dialog-content>
    <div><b>Are you sure you want to mark the deal as dead?</b></div>

    <div class="warning-message"><mat-icon color="warn">error_outline</mat-icon> Statuses will be read-only unless the deal is resurrected.</div>

    @if (dealInfo) {
      <ul>
        <li>
          <b>Deal: </b>{{dealInfo.deal}}
        </li>
        @if (dealInfo.developer) {
          <li>
            <b>Developer: </b>{{dealInfo.developer}}
          </li>
        }
        <li>
          <b>Closing Status: </b>{{dealInfo.closingStatus ? dealInfo.closingStatus : "None"}}
        </li>
      </ul>
    }
  </div>

  <div mat-dialog-actions style="float:right;margin:20px;">
    <button mat-button [mat-dialog-close]="{ clicked: 'Ok' }">Ok</button>
    <button mat-button [mat-dialog-close]="{ clicked: 'Cancel' }">
      Cancel
    </button>
  </div>
</div>
